import type { SubmissionController } from '@saas/api-client';

type SubmissionListQuery = NonNullable<Parameters<SubmissionController['list']>[0]['query']>;

export type VideoSort = NonNullable<SubmissionListQuery['sort']>;

export const VIDEO_SORTS = ['newest', 'oldest'] as const satisfies readonly VideoSort[];

export const DEFAULT_VIDEOS_PAGE_SIZE = 25;

/** The Videos tab's URL state is the list query itself; anything unset reads as its default. */
export type VideosSearch = SubmissionListQuery;
